import type { UseQueryResult } from "@tanstack/react-query";

import { useOrgScopedQuery } from "../../query/scope";
import { fetchTasks } from "./api";
import type { TaskListOptions, TaskResponse } from "./api";

// Org-scoped запрос (см. `src/query/scope.ts`). Polling-каждые-2-сек —
// самый дешёвый «live»-апдейт. SSE по follow-up'у.
const POLL_INTERVAL_MS = 2000;

export function useTasks(
  options: TaskListOptions = {},
): UseQueryResult<TaskResponse[], Error> {
  const { activeOnly = false, statuses = [], sort, order } = options;
  return useOrgScopedQuery<TaskResponse[]>({
    // Смысловые параметры выборки (разные фильтр/сортировка — разный
    // кэш); statuses сериализуем join'ом, чтобы массив давал стабильный
    // ключ.
    key: ["tasks", activeOnly, statuses.join(","), sort ?? null, order ?? null],
    queryFn: () => fetchTasks(options),
    refetchInterval: POLL_INTERVAL_MS,
    retry: false,
  });
}
